const action = {
    sign_in: 'Увійти',
    continue: 'Продовжити',
    continue_as: 'Продовжити як {{name}}',
    create_account: 'Створити обліковий запис',
    create_account_without_linking: 'Створити новий замість цього',
    create: 'Створити',
    enter_passcode: 'Введіть код підтвердження',
    confirm: 'Підтвердити',
    cancel: 'Скасувати',
    save_password: 'Зберегти пароль',
    bind: 'Зв’язати з {{address}}',
    bind_and_continue: 'Зв’язати та продовжити',
    back: 'Повернутися',
    nav_back: 'Назад',
    nav_skip: 'Пропустити',
    agree: 'Погодитися',
    got_it: 'Зрозуміло',
    sign_in_with: 'Продовжити з {{name}}',
    forgot_password: 'Забули пароль?',
    switch_to: 'Перемкнутися на {{method}}',
    sign_in_via_passcode: 'Увійти за допомогою коду підтвердження',
    sign_in_via_password: 'Увійти за допомогою пароля',
    change: 'Змінити {{method}}',
    link_another_email: 'Зв’язати іншу електронну пошту',
    link_another_phone: 'Зв’язати інший телефон',
    link_another_email_or_phone: 'Зв’язати іншу електронну пошту або телефон',
    show_password: 'Показати пароль',
    copy: 'Копіювати',
    verify_via_passkey: 'Підтвердити за допомогою ключа доступу',
    download: 'Завантажити',
    single_sign_on: 'Єдиний вхід (SSO)',
    authorize: 'Авторизуватися',
    use_another_account: 'Використати інший обліковий запис',
    back_to_current_account: 'Повернутися до поточного облікового запису',
};
export default Object.freeze(action);
